import { render } from "./ProfilePage.vue?vue&type=template&id=5cf5e3ca&scoped=true&ts=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&lang=ts"

import "./ProfilePage.vue?vue&type=style&index=0&id=5cf5e3ca&lang=stylus"
import "./ProfilePage.vue?vue&type=style&index=1&id=5cf5e3ca&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf5e3ca"]])

export default __exports__